import * as React from 'react';
import {Badge} from 'reactstrap';
import {Link} from 'react-router-dom';

interface TopbarNavLinkProps {
    icon?: string;
    new?: boolean;
    route: string;
    title: string;
}

class TopbarNavLink extends React.PureComponent<TopbarNavLinkProps> {
    public render() {
        return (
            <Link to={this.props.route} className='topbar__link'>
                {this.props.icon ? <span className={`topbar__link-icon lnr lnr-${this.props.icon}`}/> : ''}
                <p className='topbar__link-title'>
                    {this.props.title}
                    {this.props.new ? <Badge className='topbar__link-badge'><span>New</span></Badge> : ''}
                </p>
            </Link>
        )
    }
}

export default TopbarNavLink;


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/topbar_nav/topbar-nav-link.tsx